import { Platform } from "@angular/cdk/platform";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { NzConfigService, WithConfig } from "ng-zorro-antd/core/config";
import { NzAvatarComponent } from "ng-zorro-antd/avatar";
import { UiAvatarShapeType, UiAvatarSize, UiAvatarType } from "@webapp/ui/avatar/avatar.models";
import { UiSizeLDSType } from "../core/models/ui-size.models";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiTooltipPosition } from "../tooltip/tooltip.models";
import { UiTSType } from "../core/models/ui-type.models";
import { ThemeType } from "@ant-design/icons-angular";

@Component({
  selector: "ui-avatar",
  exportAs: "uiAvatar",
  templateUrl: "avatar.component.html",
  styleUrls: ["./avatar.component.less"],
  host: {
    "[class.ui-avatar-x-small]": `size === 'xs'`,
    "[class.ui-avatar-small]": `size === 'sm'`,
    "[class.ui-avatar-medium]": `size === 'md'`,
    "[class.ui-avatar-large]": `size === 'lg'`,
    "[class.ui-avatar-x-large]": `size === 'xl'`,
    "[class.ant-avatar-circle]": `nzShape === 'circle'`,
  },
})
export class UiAvatarComponent extends NzAvatarComponent {
  public nzShape: UiAvatarShapeType = "circle";
  public nzSize: UiSizeLDSType | number = "default";
  public nzGap = 4;

  @Input("uiSize")
  @WithConfig()
  public size: UiAvatarSize = "xs";

  @Input("uiType")
  public type?: UiAvatarType;

  @Input("uiPicture")
  public nzSrc?: string;

  @Input("uiAlt")
  public nzAlt?: string;

  @Input("uiIcon")
  public nzIcon?: string;

  @Input("uiTheme")
  public nzTheme?: ThemeType;

  @Input("uiBgColor")
  public bgColor?: string;

  @Input("uiDisabled")
  @InputBoolean()
  public disabled?: boolean;

  @Input("uiTooltipTitle")
  public tooltipTitle?: UiTSType;

  @Input("uiTooltipPlacement")
  public tooltipPlacement?: UiTooltipPosition;

  @Output("error") public readonly nzError = new EventEmitter<Event>();

  get isIcon(): boolean {
    return this.type === "icon";
  }

  get isPicture(): boolean {
    return this.type === "picture";
  }

  constructor(nzConfigService: NzConfigService, elementRef: ElementRef, cdr: ChangeDetectorRef, platform: Platform) {
    super(nzConfigService, elementRef, cdr, platform);
  }
}
